import React from 'react';

const TONES = {
  color: { bars: ['#0B7A82', '#5BAA6A', '#EE6C4D'], sun: '#F4A62A', os: '#0B7A82', ink: '#1E2A33' },
  light: { bars: ['#5FD0D6', '#7FC68C', '#F58468'], sun: '#F7B84B', os: '#5FD0D6', ink: '#FFFFFF' },
  mono: { bars: ['currentColor', 'currentColor', 'currentColor'], sun: 'currentColor', os: 'currentColor', ink: 'currentColor' },
};

export function Logo({ variant = 'full', size = 32, tone = 'color' }) {
  const t = TONES[tone] || TONES.color;
  const mark = (
    <svg width={size} height={size} viewBox="0 0 48 48" style={{ flex: 'none' }} aria-hidden="true">
      <rect x="6" y="30" width="8" height="12" rx="4" fill={t.bars[0]} />
      <rect x="18" y="24" width="8" height="18" rx="4" fill={t.bars[1]} />
      <rect x="30" y="18" width="8" height="24" rx="4" fill={t.bars[2]} />
      <path d="M8 22Q22 4 37 8" fill="none" stroke={t.sun} strokeWidth="3" strokeLinecap="round" />
      <circle cx="41" cy="9" r="5" fill={t.sun} />
    </svg>
  );
  const word = (
    <span style={{ fontFamily: 'var(--font-display)', fontSize: size * 0.78, lineHeight: 1, letterSpacing: '-0.035em', fontWeight: 700, color: t.ink }}>
      Equa<span style={{ fontWeight: 500, color: t.os }}>OS</span>
    </span>
  );
  if (variant === 'mark') return mark;
  if (variant === 'wordmark') return word;
  return <span style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.3 }} role="img" aria-label="EquaOS">{mark}{word}</span>;
}
